// slices/accountInfo/RewardDistributionData.ts
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  getRawVestaFarmDistributionAmount,
  RawVestaComputedDistribution
} from 'helpers/api/rawVesta/getRawVestaFarmDistributionAmount';
import {
  getRewardDistributionData,
  RewardDistributionData
} from 'helpers/api/rawVesta/getRewardDistributionData';

interface RewardDistributionAgg {
  expectedRewardDistributionData: RewardDistributionData[] | null;
  computedRewardDistributionData: RawVestaComputedDistribution[] | null;
}

interface RewardDistributionDataState {
  // your state fields
  data: RewardDistributionAgg | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: RewardDistributionDataState = {
  // initialize fields
  data: null,
  status: 'loading',
  error: null
};

export const fetchRewardDistributionData = createAsyncThunk(
  'rawVestaMinterDistributionData/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const computedData = await getRawVestaFarmDistributionAmount();
      const expectedData = await getRewardDistributionData();
      const data: RewardDistributionAgg = {
        expectedRewardDistributionData: expectedData,
        computedRewardDistributionData: computedData
      };
      console.log('raw vesta minter distribution data', data);
      return data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.message);
    }
  }
);

const RewardDistributionDataSlice = createSlice({
  name: 'rawVestaMinterContractInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRewardDistributionData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        fetchRewardDistributionData.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = 'succeeded';
          state.data = action.payload;
        }
      )
      .addCase(
        fetchRewardDistributionData.rejected,
        (state, action: PayloadAction<any>) => {
          state.status = 'failed';
          state.error = action.payload;
        }
      );
  }
});

export default RewardDistributionDataSlice.reducer;
